






























































































































import { getVendingStatisticsData, getVendingStatisticsSummary } from "@/domain/backend/vending";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import moment = require("moment");
import { ExtraData, StatisticData } from "@/domain/api";

type VendingStatisticsColor = "red" | "orange" | "green" | "";

interface VendingStatisticsItem {
  section: string;
  subsection: string;
  name: string;
  type?: string;
  color: VendingStatisticsColor;
  category: string;
}

@Component({
  components: { DatePicker }
})
export default class VendingStatistics extends Vue {
  @Prop() tcod!: string | null;
  isLoading = false;
  dialog = false;
  dialogExtraData = false;
  summary: ExtraData | null = null;
  from: string = moment().format("YYYY-MM-DD");
  to: string = moment().format("YYYY-MM-DD");

  // QUERY ONE CATEGORY
  selectedItem: VendingStatisticsItem | null = null;
  result: StatisticData[] | null = null;
  extraData: ExtraData | null = null;
  extraDataKeys: string[] | null = null;

  @Watch("tcod")
  async setSummary() {
    this.executeSearch();
  }

  created() {
    this.executeSearch();
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  showExtraData(extraData: ExtraData) {
    this.extraData = extraData || null;
    if (this.extraData) {
      this.extraDataKeys = Object.keys(this.extraData);
      this.dialogExtraData = true;
    }
  }

  get sections() {
    return [
      {
        name: "PAYTEF",
        displayName: "PAYTEF"
      },
      {
        name: "MDB",
        displayName: "MDB"
      },
      {
        name: "OTHER",
        displayName: "OTHER"
      }
    ];
  }

  get summaryBySection() {
    const nnSummary = this.summary;
    if (!nnSummary) return [];
    const availableCategories = Object.keys(nnSummary).map((category) => {
      let btn = this.buttons.find((btn) => btn.category === category);
      if (!btn) {
        btn = this.newItem(category, "");
      }
      return { category, count: nnSummary[category], btn };
    });
    const result = this.sections.map((s) => {
      const categories = availableCategories.filter((cat) => cat.btn.section === s.name);
      categories.sort((a, b) => this.compareItems(a.btn, b.btn));
      return {
        section: s,
        categories
      };
    });
    return result;
  }

  compareItems(a: VendingStatisticsItem, b: VendingStatisticsItem): number {
    if (a.color === b.color) {
      if (a.name === b.name) return 0;
      return a.name < b.name ? -1 : 1;
    }
    return this.colorPoints(b) - this.colorPoints(a);
  }

  colorPoints(a: VendingStatisticsItem): number {
    switch (a.color) {
      case "green":
        return 5;
      case "orange":
        return 4;
      case "red":
        return 3;
    }
    return 1;
  }

  async executeSearch() {
    if (this.tcod && !this.disableSearch) {
      this.isLoading = true;
      this.summary = await getVendingStatisticsSummary(this.tcod, this.from, this.to);
      this.isLoading = false;
    }
  }

  getTextColor(color: string) {
    if (color == "red") return "red--text";
    if (color == "green") return "green--text";
    if (color == "orange") return "orange--text text--darken-4";
    return "blue--text";
  }

  getBgColor(color: string) {
    if (color == "red") return "red lighten-5";
    if (color == "green") return "green lighten-5";
    if (color == "orange") return "orange lighten-5";
    return "blue lighten-5";
  }

  getSectionButtons(sectionName: string) {
    return this.buttons.filter((e) => e.section === sectionName);
  }

  async getData(item: VendingStatisticsItem) {
    this.selectedItem = item;
    if (!this.tcod) return;
    this.result = await getVendingStatisticsData(this.tcod, item.category, this.from, this.to);
    this.dialog = true;
  }

  get disableSearch() {
    if (moment(this.to).diff(moment(this.from), "days") + 1 < 8) return false;
    return true;
  }

  get tableHeaders() {
    return [
      { text: "TIMESTAMP", value: "timestamp", sortable: true },
      { text: "TCOD", value: "tcod", sortable: true },
      { text: "LEVEL", value: "level", sortable: true },
      { text: "QUANTITY", value: "quantity", sortable: true },
      { text: "DESCRIPTION", value: "description", sortable: true },
      { text: "CATEGORY", value: "category", sortable: true },
      { text: "EXTRA DATA", value: "extraData", sortable: false }
    ];
  }

  newItem(category: string, color: VendingStatisticsColor = "", fixedSection?: string): VendingStatisticsItem {
    const catParts = category.split(".");
    const nameParts = catParts[1].split("_").map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    let section = "";
    let namePrefix = "";
    if (fixedSection) {
      section = fixedSection;
      namePrefix = catParts[0] + " ";
    } else if (this.sections.some((s) => s.name === catParts[0])) {
      section = catParts[0];
    } else {
      section = "OTHER";
      namePrefix = catParts[0] + " ";
    }
    let type = "";
    if (catParts[0] == "PAYTEF") {
      type = nameParts.pop() || "";
    } else {
      type = nameParts[nameParts.length - 1];
    }
    const btn: VendingStatisticsItem = {
      section: section,
      subsection: type /* subsection no se utiliza en la interfaz */,
      name: namePrefix + nameParts.join(" "),
      type: type,
      color: color,
      category: category
    };
    return btn;
  }

  get buttons(): VendingStatisticsItem[] {
    return [
      this.newItem("PAYTEF.CONNECTED", ""),
      this.newItem("PAYTEF.DISCONNECTED", "orange"),
      this.newItem("PAYTEF.SALE_START", "", "OTHER"),
      this.newItem("PAYTEF.SALE_APPROVED", "green"),
      this.newItem("PAYTEF.SALE_DENIED", "orange"),
      this.newItem("PAYTEF.SALE_ERROR", "red"),
      this.newItem("PAYTEF.REFUND_START", "", "OTHER"),
      this.newItem("PAYTEF.REFUND_APPROVED", "orange"),
      this.newItem("PAYTEF.REFUND_DENIED", "red"),
      this.newItem("PAYTEF.REFUND_ERROR", "red"),
      this.newItem("PAYTEF.AUTH_START", "", "OTHER"),
      this.newItem("PAYTEF.AUTH_APPROVED", "", "OTHER"),
      this.newItem("PAYTEF.AUTH_DENIED", "orange"),
      this.newItem("PAYTEF.AUTH_ERROR", "red"),
      this.newItem("PAYTEF.AUTH_CLOSE_START", "", "OTHER"),
      this.newItem("PAYTEF.AUTH_CLOSE_APPROVED", "green"),
      this.newItem("PAYTEF.AUTH_CLOSE_DENIED", "red"),
      this.newItem("PAYTEF.AUTH_CLOSE_ERROR", "red"),
      this.newItem("PAYTEF.AUTH_CANCEL_START", "", "OTHER"),
      this.newItem("PAYTEF.AUTH_CANCEL_APPROVED", "orange"),
      this.newItem("PAYTEF.AUTH_CANCEL_DENIED", "red"),
      this.newItem("PAYTEF.AUTH_CANCEL_ERROR", "red"),
      this.newItem("MDB.ONLINE"),
      this.newItem("MDB.OFFLINE", "orange"),
      this.newItem("MDB.RESET"),
      this.newItem("MDB.JUST_RESET"),
      this.newItem("MDB.SESSION_START"),
      this.newItem("MDB.SESSION_CANCEL"),
      this.newItem("MDB.SESSION_COMPLETE"),
      this.newItem("MDB.VEND_REQUEST"),
      this.newItem("MDB.VEND_SUCCESS", "green"),
      this.newItem("MDB.VEND_CANCEL"),
      this.newItem("MDB.VEND_FAILURE", "orange"),
      this.newItem("MDB.REVALUE_APPROVED", "green"),
      this.newItem("MDB.REVALUE_DENIED", "orange"),
      this.newItem("MDB.READER_ENABLED"),
      this.newItem("MDB.READER_DISABLED"),
      this.newItem("MDB.CONFIG_DATA"),
      this.newItem("MDB.CONFIG_EXPANSION"),
      this.newItem("PULSE.TRIGGERED", "green"),
      this.newItem("PULSE.FAILED", "red"),
      this.newItem("APP.STARTED"),
      this.newItem("TOPAY.SEND_ERROR", "red")
    ];
  }
}
